var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 2C4.17185 2 2 4.17185 2 6.83333C2 9.49481 4.17185 11.6667 6.83333 11.6667C7.92439 11.6667 8.92964 11.2977 9.74023 10.6836L12.862 13.8047C12.9234 13.8687 12.997 13.9198 13.0784 13.9549C13.1598 13.9901 13.2474 14.0087 13.3361 14.0096C13.4248 14.0105 13.5128 13.9937 13.5949 13.9602C13.6771 13.9267 13.7517 13.8771 13.8144 13.8144C13.8771 13.7517 13.9267 13.6771 13.9602 13.5949C13.9937 13.5128 14.0105 13.4248 14.0096 13.3361C14.0087 13.2474 13.9901 13.1598 13.9549 13.0784C13.9198 12.997 13.8687 12.9234 13.8047 12.862L10.6836 9.74023C11.2977 8.92964 11.6667 7.92439 11.6667 6.83333C11.6667 4.17185 9.49481 2 6.83333 2ZM6.83333 3.33333C8.77423 3.33333 10.3333 4.89244 10.3333 6.83333C10.3333 7.76524 9.97135 8.60687 9.38281 9.23242C9.32552 9.2739 9.2752 9.32422 9.23372 9.38151C8.60803 9.9708 7.7659 10.3333 6.83333 10.3333C4.89244 10.3333 3.33333 8.77423 3.33333 6.83333C3.33333 4.89244 4.89244 3.33333 6.83333 3.33333Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d61ec4bbd77a886223f5b35d5908a843.svg";
export { ForwardRef as ReactComponent };